import React, { memo } from 'react';
import { FormattedMessage } from 'react-intl';
import { format } from 'date-fns';
import { useTranslations } from '../../../../../../../../../../../../hooks/useTranslations';

const NotificationsListItem = () => {
  const { attachPrefix } = useTranslations(
    'ConversationsAndFeedbacks.ConversationTemplates.ConversationTemplatePhone.Conversation.ConversationItem.NotificationsListItem'
  );

  const currentHour = format(new Date(), 'HH:HH a');

  return (
    <div className="ConversationTemplateRangeQuestionItem">
      <div className="ConversationTemplateRangeQuestionItem__question d-flex flex-column">
        <span className="ConversationTemplatePlainTextItem__content__text">
          <FormattedMessage id={attachPrefix('notificationsList')} />
        </span>
        <span className="ConversationTemplatePlainTextItem__content__hour">
          {currentHour}
        </span>
      </div>
    </div>
  );
};

export default memo(NotificationsListItem);
